import React, { FC, useEffect } from 'react';
import { compose } from 'react-recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { UserRegistration } from '@dev/ee-modules';
import { ActivateUserPayload, ProductCode } from '@dev/ee-api/ee-api-models';
import { parse } from 'query-string';

import { UrlSearchParams } from '@/store/users/types';
import useMobile from '../../services/hooks/useMobile';
import { HomePaths } from '../../services/dictionaries/Paths';
import { ApplicationState as State } from '../../store';
import { ActivateUser, CheckIfUserIsActivated } from '../../store/users/actions';
import { RegisterUserProps } from './RegisterUserInterface';

const mapState = (state: State, ownProps: RegisterUserProps): RegisterUserProps => ({
    ...ownProps,
    users: state.users,
});

const dispatchProps = {
    ActivateUser,
    CheckIfUserIsActivated,
};

interface DispatchProps {
    ActivateUser(params: ActivateUserPayload): any;
    CheckIfUserIsActivated(userName: string, verificationCode: string): any;
}

type ExtendedProps = RegisterUserProps & DispatchProps;

const RegisterUser: FC<ExtendedProps> = (props: ExtendedProps): JSX.Element => {
    const isMobile = useMobile();
    const query: UrlSearchParams = parse(location.href.split('?')[1] || '', { arrayFormat: 'comma', decode: false });

    useEffect((): void => {
        if (query.userName && query.verification) {
            props.CheckIfUserIsActivated(query.userName, query.verification);
        }
    }, []);

    return (
        <UserRegistration
            paths={{ Login: HomePaths.Login }}
            isMobile={isMobile}
            userEmail={props.users?.userRegistrationCheck?.userStatus?.UserName}
            errorMessage={props.users?.userRegistrationCheck?.errorMessage}
            productCode={ProductCode.Legacy}
            {...props}
        />
    );
};

export default compose(
    withTranslation(),
    connect<RegisterUserProps, DispatchProps>(mapState, dispatchProps)
)(RegisterUser);
